import { Friendship } from '../models';
import { FriendshipRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class AcceptFriendRequestUseCase {
  constructor(private friendshipRepository: FriendshipRepository) {}

  async execute(friendshipId: string): Promise<Friendship> {
    logger.debug('AcceptFriendRequest', 'Accepting friend request', { friendshipId });

    const friendship = await this.friendshipRepository.acceptRequest(friendshipId);

    logger.debug('AcceptFriendRequest', 'Successfully accepted friend request');

    return friendship;
  }
}
